var s = (i, t, r) => new Promise((a, n) => {
  var l = (e) => {
    try {
      o(r.next(e));
    } catch (c) {
      n(c);
    }
  }, p = (e) => {
    try {
      o(r.throw(e));
    } catch (c) {
      n(c);
    }
  }, o = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(l, p);
  o((r = r.apply(i, t)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function u(i) {
  return s(this, null, function* () {
    const {
      data: t
    } = yield d.post(
      "/mtdsretail/productionOrder/getTechnicalReviewUrl",
      i
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  u as postGetTechnicalReviewUrl
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/productionOrder/getTechnicalReviewUrl/post.js
// module id = 1783
// module chunks = 41